/**
 * Quick 260916-fk0 — board column ordering picker.
 *
 * Sits next to BoardFilterBar in the board toolbar and borrows its control
 * styling so the two read as one row. Deliberately a plain <select>: three
 * options do not justify the outside-click/Esc popover machinery the filter
 * panel needs, and a native control is keyboard- and screen-reader-correct for
 * free.
 */
import { BOARD_SORT_MODES, BOARD_SORT_LABELS, type BoardSortMode } from '../../utils/boardSort';

const CONTROL_CLASS =
  'rounded-md border border-ms-border bg-ms-surface px-2 py-1 text-[12px] ' +
  'text-ms-text focus:outline-none focus:ring-1 focus:ring-ms-orange/40';

export interface BoardSortControlProps {
  value: BoardSortMode;
  onChange: (next: BoardSortMode) => void;
}

export function BoardSortControl({ value, onChange }: BoardSortControlProps) {
  return (
    <label className="flex items-center gap-1.5">
      <span className="text-[11px] font-medium text-ms-text-secondary">Sort</span>
      <select
        className={CONTROL_CLASS}
        value={value}
        onChange={(e) => onChange(e.target.value as BoardSortMode)}
        aria-label="Sort tasks within each column"
      >
        {BOARD_SORT_MODES.map((mode) => (
          <option key={mode} value={mode}>
            {BOARD_SORT_LABELS[mode]}
          </option>
        ))}
      </select>
    </label>
  );
}
